import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FaInfoCircle } from 'react-icons/fa';
import { CriteriaKey } from '../types';
import './CriteriaButton.scss';

interface CriteriaButtonProps {
  criteriaKey: CriteriaKey;
  label: string;
  subtitle?: string;
  isSubtitleLink?: boolean;
  isActive: boolean;
  onClick: (key: CriteriaKey) => void;
  onInfoClick?: () => void;
}

const CriteriaButton: React.FC<CriteriaButtonProps> = ({
  criteriaKey,
  label,
  subtitle,
  isSubtitleLink,
  isActive,
  onClick,
  onInfoClick,
}) => {
  const handleInfoClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onInfoClick?.();
  };

  return (
    <button
      type="button"
      className={`criteria-button${isActive ? ' criteria-button--active' : ''}`}
      onClick={() => onClick(criteriaKey)}
      aria-pressed={isActive}
      data-testid={`sepsis-criteria-${criteriaKey}`}
    >
      {onInfoClick && !isSubtitleLink && (
        <button
          type="button"
          className="criteria-button__info"
          onClick={handleInfoClick}
          aria-label="מידע נוסף"
          tabIndex={0}
          data-testid={`sepsis-criteria-${criteriaKey}-info`}
        >
          <FaInfoCircle />
        </button>
      )}
      <div className="criteria-button__content">
        <span
          className="criteria-button__label"
          data-testid={`sepsis-criteria-${criteriaKey}-label`}
        >
          {label}
        </span>
        {subtitle && (
          <span
            className={`criteria-button__subtitle${
              isSubtitleLink ? ' criteria-button__subtitle--link' : ''
            }`}
            onClick={isSubtitleLink ? handleInfoClick : undefined}
            role={isSubtitleLink ? 'button' : undefined}
            tabIndex={isSubtitleLink ? 0 : undefined}
            data-testid={`sepsis-criteria-${criteriaKey}-subtitle`}
          >
            {subtitle}
          </span>
        )}
      </div>
      {isActive && (
        <span className="criteria-button__check">
          <FontAwesomeIcon icon={faCheck} />
        </span>
      )}
    </button>
  );
};

export default CriteriaButton;
